import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { DateUtil } from '../../shared/date_util';
import { DroneComponentState } from '../../shared/state-interface';
import { DroneModelsComponent } from '../../ui-components/drone-models/drone-models.component';
import { RegisteredDrone } from './registered-drone.model';

@Component({
    selector: 'app-drone-component',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatDatepickerModule,
        DroneModelsComponent
    ],
    templateUrl: './drone.component.html',
    styleUrl: './drone.component.css'
})
export class DroneComponent {

    @ViewChild(DroneModelsComponent) droneModelsComponent!: DroneModelsComponent;
    @Input() updateDrone: boolean = false;
    @Output() messageEvent = new EventEmitter<string>();

    protected droneForm = new FormGroup({
        serialNumber: new FormControl(""),
        manufactureDate: new FormControl()
    });

    private _minDate: Date;
    private _maxDate: Date;

    public constructor() {
        this._maxDate = new Date();
        this._minDate = DateUtil.adjustDate(this._maxDate, -6);
        this.droneForm.controls.manufactureDate.setValue(this._maxDate);
    }

    public getState(): DroneComponentState {
        const state: DroneComponentState = {} as DroneComponentState;
        state.droneForm = this.droneForm;
        state.droneModelsComponentState = this.droneModelsComponent.getState();
        return state;   
    }

    public restoreState(state: DroneComponentState) {
        this.droneForm = state.droneForm;
        this.droneModelsComponent.restoreState(state.droneModelsComponentState);
    }

    public init() {
        this.droneModelsComponent.init();
    }

    public receiveMessage(value: string) {
        this.messageEvent.emit(value);
    }

    public populateFormFromModel(drone: RegisteredDrone) {
        this.droneModelsComponent.model = drone.model;
        this.droneModelsComponent.droneModelCtl.disable();
        this.serialNumberCtl.setValue(drone.serial_number);
        this.serialNumberCtl.disable();
        this.manufactureDateCtl.setValue(drone.manufacture_date);
        this.manufactureDateCtl.disable();
    }

    public createModelFromForm(drone: RegisteredDrone): RegisteredDrone {
        drone.serial_number = this.serialNumberCtl.value;
        drone.model = this.droneModelsComponent.selectedModel;
        drone.manufacture_date = this.manufactureDateCtl.value;
        return drone;
    }

    protected get minDate(): Date {
        return this._minDate;
    }
    
    protected get maxDate(): Date {
        return this._maxDate;
    }
    
    public get serialNumberCtl(): FormControl {
        return this.droneForm.controls.serialNumber;
    }

    public get manufactureDateCtl(): FormControl {
        return this.droneForm.controls.manufactureDate;
    }
}